<template>
    <component :is="icon"></component>
</template>

<script>
    import arrowLeft from "./icons/arrow-left";
    import arrowRight from "./icons/arrow-right";
    import pencil from "./icons/pencil";
    import user from "./icons/user";
    import caret from "./icons/caret";
    import location from "./icons/location";
    import eda from "./icons/eda";
    import defa from "./icons/defa";
    import list from "./icons/list";
    import stats from "./icons/stats";
    import warning from "./icons/warning";

    export default {
        name: "icon-check-round",
        components: {
            arrowLeft,
            arrowRight,
            pencil,
            user,
            caret,
            location,
            eda,
            defa,
            stats,
            list,
            warning,
        },
        props: {
            icon: {type: String, default: ""},
            fill: {type: String, default: "#000"}
        }
    }
</script>

<style scoped>


</style>